//contact Us
export const START_CONTACTUS = "START_CONTACTUS";
export const CONTACTUS_SUCCESS = "CONTACTUS_SUCCESS";
export const CONTACTUS_FAIL = "CONTACTUS_FAIL";